import React from "react";
import { Box, Card, Typography } from "@mui/material";
import InputField from "../../../Components/InputField";
import muiStyles from "../styles/muiStyles";
import { useTranslation } from "react-i18next";

const UploadTOS = ({ values, handleChange, disableFields }) => {
  const {
    inputGridStyles,
    cardStyles,
    uploadTOSCardTextStyles,
    uploadTOSDescriptionStyles,
  } = muiStyles;

  const { t } = useTranslation("page-community-settings");

  return (
    <Box sx={inputGridStyles}>
      <Card sx={cardStyles}>
        <Box sx={{ width: "100%" }}>
          <Typography sx={uploadTOSCardTextStyles}>
            {t("tos_community_suppliers.title")}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={uploadTOSDescriptionStyles}
          >
            {t("tos_community_suppliers.sub_title")}
          </Typography>

          <InputField
            name="tos_supplier"
            label={t("tos_community_suppliers.terms_of_service")}
            value={values.tos_supplier}
            onChange={handleChange}
            placeholder={t("tos_community_suppliers.description")}
            disabled={disableFields}
            dir="auto"
            multiline
            minRows={4}
            maxRows={6}
          />
        </Box>
      </Card>
      <Card sx={cardStyles}>
        <Box sx={{ width: "100%" }}>
          <Typography sx={uploadTOSCardTextStyles}>
            {t("tos_community_members.title")}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={uploadTOSDescriptionStyles}
          >
            {t("tos_community_members.sub_title")}
          </Typography>

          <InputField
            name="tos_member"
            label={t("tos_community_members.terms_of_service")}
            value={values.tos_member}
            onChange={handleChange}
            placeholder={t("tos_community_members.description")}
            disabled={disableFields}
            dir="auto"
            multiline
            minRows={4}
            maxRows={6}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default UploadTOS;
